import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { PaymentInputContainer } from '../../../styles'

const HashInput = ({
  hash,
  onChange,
  disabled = false,
}: {
  hash: string
  onChange: (value: string) => void
  disabled?: boolean
}) => {
  const { t } = useTranslation()

  return (
    <Container $disabled={disabled}>
      <textarea value={hash} onChange={(e) => onChange(e.target.value)} placeholder={t('Enter TxID/TxHash')} rows={3} />
    </Container>
  )
}

export const Container = styled(PaymentInputContainer)<{ $disabled?: boolean }>`
  padding: 8px 6px;
  height: fit-content;
  textarea {
    padding: 0x 6px;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
    font-weight: 400;
    resize: none;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};
    padding: 0px 6px;
  }
`

export default memo(HashInput)
